import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useCompanyBrand } from '../../hooks/useCompanyBrand';

// Way back to the company's main website (Company Profile website), opened in a new tab.
export const PortalSiteLink = () => {
  const brand = useCompanyBrand();
  const url = (brand?.website || '').replace(/\/+$/, '');
  if (!/^https?:\/\//.test(url)) return null;
  return (
    <a
      href={`${url}/`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="portal-visit-site-link"
      aria-label={`Visit ${brand.brand_name || brand.primary_domain}`}
      title={`Visit ${brand.brand_name || brand.primary_domain}`}
      className="inline-flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium text-amber-700 hover:bg-amber-50 hover:text-amber-800 transition-colors"
    >
      <ExternalLink className="h-4 w-4" />
      <span className="hidden sm:inline">Visit {brand.brand_name || brand.primary_domain}</span>
      <span className="sm:hidden">Website</span>
    </a>
  );
};
